import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { filter, finalize, map, shareReplay } from 'rxjs/operators';

/**
 *  KÖNYVELÉSI TÖRZSLISTÁK RÖVID GYORSÍTÓTÁRA (betöltés-felmérés, 2026-11-05)
 *
 *  A számlatükröt (egy ügyfélnél 600+ sor), a partnereket, a munkaszámokat, a kettős beállítást, a bevallási sorokat
 *  és a NAV-adókódokat 4–7 képernyő tölti le újra és újra, ráadásul hétféle úton (NaploService, getAbs, közvetlen
 *  http.get, komponens-segédek). Ezért itt, a HTTP-rétegben tároljuk őket:
 *    – csak GET, csak az alábbi címek, URL (paraméterekkel) szerint, 30 másodpercig; az egyszerre futó azonos kérés
 *      egyetlen hálózati hívás;
 *    – MINDEN írás (POST/PUT/PATCH/DELETE) a könyvelési végpontokra az egész tárat üríti – a saját módosítás azonnal
 *      látszik;
 *    – minden feliratkozó saját mély másolatot kap (a szerkesztő képernyők a listát helyben módosítják).
 */
const TAROLHATO = [
  /\/kettos\/szamlatukor\/[^/?]+(\?|$)/,
  /\/kettos\/munkaszamok\/[^/?]+(\?|$)/,
  /\/kettos\/beallitas\/[^/?]+(\?|$)/,
  /\/naplo\/partnerek\/[^/?]+(\?|$)/,
  /\/naplo-naplok\/bevallas-sorok(\?|$)/,
  /\/nav-adokod(\?|$)/,
];
const URITO = /\/(kettos|naplo|naplo-naplok|nav-adokod|naplo-bank|naplo-rlb)(\/|\?|$)/;
const ELETTARTAM_MS = 30_000;

@Injectable()
export class TorzsGyorsitotarInterceptor implements HttpInterceptor {
  private tar = new Map<string, { ido: number; r$: Observable<HttpResponse<any>> }>();

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.urlWithParams;
    if (req.method !== 'GET') {
      if (URITO.test(req.url)) {
        this.tar.clear();
        return next.handle(req).pipe(finalize(() => this.tar.clear()));
      }
      return next.handle(req);
    }
    if (!TAROLHATO.some((m) => m.test(req.url))) return next.handle(req);
    const most = Date.now();
    let t = this.tar.get(url);
    if (!t || most - t.ido > ELETTARTAM_MS) {
      const r$ = next.handle(req).pipe(
        filter((e): e is HttpResponse<any> => e instanceof HttpResponse),
        shareReplay({ bufferSize: 1, refCount: false }),
      );
      t = { ido: most, r$ };
      this.tar.set(url, t);
      //  Hibás válasz ne maradjon a tárban.
      r$.subscribe({ error: () => { if (this.tar.get(url)?.r$ === r$) this.tar.delete(url); } });
    }
    return t.r$.pipe(map((r) => r.clone({ body: masol(r.body) })));
  }
}

function masol<T>(v: T): T {
  if (v == null || typeof v !== 'object') return v;
  try { return structuredClone(v); } catch { return JSON.parse(JSON.stringify(v)); }
}
